export const isAssetSerie = (el) => {
	if (el?.seriesId || el?.isSerie) {
		return true;
	} else {
		return false;
	}
};
